import { Component, Inject, OnInit } from '@angular/core';
import { UsuarioService } from 'src/app/data-access/usuario.service'
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { config } from 'src/app/data-access/config';
import { DOCUMENT } from '@angular/common';
import { AuthService } from 'src/app/data-access/auth.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styles: []
})
export class InicioComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.spinner.show();
    let usuarioToken = '';
    window.addEventListener('message', (event) => {
      //Se debe modificar el origen de donde se puede recibir el token de autenticación
      //if (event.origin == 'http://localhost:4200') {
      if (event.origin == 'https://espaciosdes.ibero.mx' || event.origin == 'https://espaciospru.ibero.mx' || event.origin == 'https://espacios.ibero.mx') {  
        if (event.data.type === 'jwtToken') {
          console.log(event.data.token);
          
          usuarioToken = event.data.token;
          this.activatedRoute.params.subscribe(params => {
            let usuarioDatos = params['id'];
            if (usuarioDatos == undefined) {
              this.document.location.href = config.webAppUrl;
            }
            else {
              let usuario = {
                idTipoUsuario: 0,
                cuenta: '',
                digito: '',
                token: '',
                nombre: '',
                apPat: '',
                apMat: '',
                email: '',
                claveDepartamento: 0,
                departamento: '',
                claveCoordinacion: 0,
                coordinacion: '',
                roles: '',
                estatus: true,
                dataURL: ''
              };
      
              usuario.dataURL = usuarioDatos;
              
              this.usuarioService.validaCuenta(usuario).toPromise()
                .then(data => {
                  
                  // console.log(data);
                  
                  let user = data;
                  user.token = usuarioToken;
                  //console.log(user);
                  if(!user.estatus){
                    this.router.navigate(['/inactivo']);
                    this.spinner.hide();
                    return true;
                  }
                  
                  if(!usuario.estatus){
                    this.router.navigate(['/inactivo']);
                    this.spinner.hide();
                    return true;
                  }
                  this.usuarioService.addUser(user);
                  localStorage.setItem('valido', '1');
                  this.spinner.hide();
                  this.authService.verifyExpirationTime()
                  this.router.navigate(['/menu']);
      
                  if (localStorage.getItem('fullNameUndefined') == '1') {
                    localStorage.setItem('fullNameUndefined', '0');
                  }
      
                }, error => {
                  //console.log("Error returned from webservice...")
                  console.log(error)
                  //console.log("----------------------------------");
                })
            }
          });
        }else{
          Swal.fire({
            title: "Error",
            text: "Error de autenticación",
            icon: "error"
          });
        }
      } 
    });
    setTimeout(() => {
      if (usuarioToken == '') {
          this.toastr.warning("Error de autenticación");
          setTimeout(() => {
            window.close();
          },2000);
      }
    },10000);
  }

}
